import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';

const cssClasses = cva('mx-auto', {
  variants: {
    fullWidth: {
      true: '',
      false: 'max-w-[1112px] px-5 pb-4',
    },
  },
});

export default component$(
  ({ fullWidth = false }: { fullWidth: boolean }): JSX.Element => {
    return (
      <div
        class={cssClasses({
          fullWidth,
        })}
      >
        <Slot />
      </div>
    );
  }
);
